var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChair(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32.498,
    viewBox: "0 0 32 32.498",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-Chair",
    transform: "translate(-252 -70.752)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "container-icon",
    width: 32,
    height: 32,
    transform: "translate(252 71)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon-Chair-2",
    "data-name": "icon-Chair",
    d: "M30.022,8c-3.478,0-5.961.1-7.7,1.2a5.011,5.011,0,0,0-1.981,2.452,10.169,10.169,0,0,0-.8,4.3,4.994,4.994,0,0,0,.48,2.131,1.914,1.914,0,0,0,.973.893v3.88H18.3a.4.4,0,0,0-.293.452,9.015,9.015,0,0,0,1.336,3.379,1.674,1.674,0,0,0,1.277.738H21V39.611a.375.375,0,1,0,.75,0V27.424h1.5v9.141a.375.375,0,1,0,.75,0V27.424H36v9.141a.375.375,0,1,0,.75,0V27.424h1.5V39.611a.375.375,0,1,0,.75,0V27.424h.375a1.67,1.67,0,0,0,1.277-.738A7.553,7.553,0,0,0,42,23.235a.362.362,0,0,0-.375-.381H39v-3.88a1.909,1.909,0,0,0,.973-.881,3.957,3.957,0,0,0,.48-2.107,11.838,11.838,0,0,0-.715-4.308,4.845,4.845,0,0,0-1.9-2.464C35.954,7.988,32.952,7.988,30.022,8Zm0,.762c4.056-.012,5.989.152,7.42,1.083a4.036,4.036,0,0,1,1.594,2.107A10.674,10.674,0,0,1,39.7,16a2.8,2.8,0,0,1-.375,1.7c-.236.4-.522.583-.727.583H21.372c-.188,0-.47-.177-.7-.583a3.288,3.288,0,0,1-.375-1.7,10.016,10.016,0,0,1,.738-4.046,4.238,4.238,0,0,1,1.688-2.107c1.478-.933,3.844-1.083,7.3-1.083ZM21.747,19.044h16.5v3.808h-16.5Zm-2.871,4.57H41.264a7.468,7.468,0,0,1-1.2,2.6.953.953,0,0,1-.691.452H20.623a.953.953,0,0,1-.691-.452,7.145,7.145,0,0,1-1.055-2.6Z",
    transform: "translate(237.499 63.002)",
    fill: "#151515",
    stroke: "#151515",
    strokeWidth: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChair);
export default __webpack_public_path__ + "static/media/chair.a623cd3fecc0c96013d14d59f7c7cbd3.svg";
export { ForwardRef as ReactComponent };